module.exports = __webpack_public_path__ + "static/img/logo.bf772db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/images/icon/logo.png
// module id = ua/H
// module chunks = 110